import logo from './logo.svg';
import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import MapboxMap from './Components/Map';
function App() {
  return (
    <div className="App">
      <MapboxMap></MapboxMap>
    </div>
  );
}

export default App;
